import { useGetActivePaymentMethodOnFileListForContactQuery } from '../../../../__generated__/chirp/com/hubspot/payments/payment/method/management/rpc/PaymentMethodOnFileReadService.hooks';
export function useGetStoredPaymentMethodForContact(contactId) {
  return useGetActivePaymentMethodOnFileListForContactQuery({
    variables: {
      contactId
    },
    fetchPolicy: 'cache-and-network',
    useLegacyFieldNameMode: true
  });
}